import Vue from "vue";
const vm = new Vue()

export const getCourierById = async (courierId) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/superadmin/courier/${courierId}` , {
            headers: {
                Token: localStorage.getItem("access_token")
            }
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data[0])
            })
    })
}

export const getCourierInterById = async (courierId) => {
    return new Promise((resolve, reject) => { 
        vm.$http.get( vm.$API_URL + `/inter/get/courier/${courierId}` , {
            headers: {
                Token: localStorage.getItem("access_token")
            }   
        }).then((res) => {
            if (!res.data.status) {
                reject(res.data.error.message);
            }
            let resLoad
            const {
                courier_code,
                is_edit_rate,
                description,
                effective_date,
                expired_date,
                from_courier_inter,
                name,
                courier_inter_rates,
                ...responseData
            } = res.data.data
            resLoad = responseData
            const instance = ['allow_change_price', 'allow_change_rate', 'allow_change_service']
            let tempData = {}
            tempData.allowedCourier = []
            instance.forEach((response) => {
                if(resLoad[response] == 0) {
                    tempData.allowedCourier.push(response)
                }
            })
                tempData.from_courier_inter = from_courier_inter
                tempData.is_edit_rate = is_edit_rate
                tempData.courierKey = courier_code
                tempData.courierName = name
                tempData.descriptionCouier = description
                tempData.id = resLoad.id
                tempData.effective_date  = effective_date
                tempData.expired_date =  expired_date
                tempData.price = courier_inter_rates[0].price
                tempData.price_min = courier_inter_rates[0].price_min
                tempData.rate_min = courier_inter_rates[0].rate_min
                tempData.rate = courier_inter_rates[0].rate
                tempData.rate_max_discount = courier_inter_rates[0].rate_max_discount
                tempData.service_min = courier_inter_rates[0].service_min
                tempData.service = courier_inter_rates[0].service

            resolve(tempData)
        })    
    })
}

export const searchShopForRateManagement = async (search) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/list/courier` , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                courier_key: search.courierKey,
                default_courier_code: search.rateCode,
                under_by: search.underShop,
                package: search.packageShop,
                shop_code: search.shopCodeArray
            }
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data)
            })
    })
}

export const createCourierRateManagement = async (selectedShop , rateCode , forceCreate = false) => {
    return new Promise((resolve, reject) => {
        vm.$http.post( vm.$API_URL + '/shop/list/courier', {
                code_shops: selectedShop,
                default_courier_code: rateCode,
                force_create: forceCreate
            },{
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }
        )
        .then(res => {
            if (!res.data.status) {
                reject(res.data.error.message);
            }
            resolve(res.data)
        })
    })
}

export const getListCourier = async () => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + "/courier/list" , {
            headers: {
                Token: localStorage.getItem("access_token")
            }
        }).then( res => {
            if (!res.data.status) {
                reject(res.data.error.message);
            }
            resolve(res.data.data)
        })
    })
}

export const getDefaultCourier = async () => {
    return new Promise((resolve, reject) => {
        vm.$http.get(vm.$API_URL + "/shop/superadmin/couriers", {
            headers: {
                Token: localStorage.getItem("access_token")
            }
        })
        .then(res => {
            if (!res.data.status) {
                if ( res.data.error.hasOwnProperty("notices") ) {
                    reject(res.data.error.notices);
                }else{
                    reject(res.data.error.message);
                }
            }

            resolve(res.data.data)
        });
    })
}

export const getCourierServiceArea = async ( toPostcode , courierCode ) => {
    return new Promise((resolve) => {
        let serviceDelay = { status: false, notice: null }
        let serviceFreeze = { status: false, notice: null }

        vm.$http.get(
            vm.$API_URL + "/courier-service-area", { 
                headers: {Token: localStorage.getItem("access_token")}
            }
        )    
        .then((res) => {
            if ( res.data.status ){
                let data = res.data.data;
                data = data.filter( item => item.courierCode.includes( courierCode ) );
                if( data.length ){
                    if( data[0].serviceDelay.destArea.includes(String(toPostcode)) ){
                        serviceDelay.status = true;
                        serviceDelay.notice = data[0].serviceDelay.destNotice;
                    }
                    if( data[0].serviceFreeze.destArea.includes(String(toPostcode)) ){
                        serviceFreeze.status = true;
                        serviceFreeze.notice = data[0].serviceFreeze.destNotice;
                    }
                }   
            }
            resolve({ serviceDelay, serviceFreeze });
        });
    });
}